import Big from "big.js";
/**
 * Converts amount to cents
 * e.g. for Stripe purposes
 */
export const amountToCents = (amount) => {
    return new Big(amount).times(100).round(0).toNumber();
};
//# sourceMappingURL=payments.js.map